// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store'
import mandMobile from 'mand-mobile'
import 'babel-polyfill'
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()

// 引入h5样式
import 'mand-mobile/lib/mand-mobile.css'
import './styles/theme.css' // 变量使用文件

import 'lib-flexible'
import md5 from 'js-md5'
import * as filters from '@/filters'
import moment from 'moment'
import { sendError } from '@/service/http.js'

//系统错误捕获
const errorHandler = (error, vm)=>{
  console.error('抛出全局异常')
  console.error(vm)
  console.error(error)
  sendError(store.state.user.id, String(error))
}

Vue.config.errorHandler = errorHandler
Vue.prototype.$throw = (error)=> errorHandler(error,this)

// H5复制粘贴
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 全局事件
// Vue.prototype.$EventBus = new Vue()
Vue.prototype.$store = store

Vue.prototype.$moment = moment // 赋值使用
moment.locale('zh-cn') // 需要汉化

// 全局过滤器
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

Vue.use(mandMobile)
Vue.config.productionTip = false
Vue.prototype.$md5 = md5

if (sessionStorage.getItem('store')) {
    store.replaceState(
        Object.assign({}, store.state, JSON.parse(sessionStorage.getItem('store')))
    )
}

window.addEventListener('beforeunload', () => {
    sessionStorage.setItem('store', JSON.stringify(store.state))
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    store,
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js